import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { cn } from "@/lib/utils";

export function Combobox({ options, value, onChange, placeholder = "Select…", testid }) {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => (o.value ?? o) === value);
  const label = selected ? (selected.label ?? selected) : "";
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="w-full h-10 px-3 flex items-center justify-between rounded-md border border-border bg-card text-sm text-foreground hover:border-primary/60 focus:outline-none focus:ring-2 focus:ring-orange-400"
        >
          <span className={cn("truncate", !label && "text-muted-foreground")}>{label || placeholder}</span>
          <ChevronsUpDown size={15} className="text-muted-foreground shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] z-[1200]" align="start">
        <Command>
          <CommandInput placeholder="Search…" className="text-sm" />
          <CommandList>
            <CommandEmpty>No match found.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => {
                const val = o.value ?? o;
                const lab = o.label ?? o;
                return (
                  <CommandItem key={val} value={lab} onSelect={() => { onChange(val); setOpen(false); }}
                    data-testid={testid ? `${testid}-opt-${val}` : undefined}>
                    <Check size={15} className={cn("mr-2", value === val ? "opacity-100 text-primary" : "opacity-0")} />
                    {lab}
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
